import { Component, Vue } from "vue-property-decorator";
import * as io from "socket.io-client";
import { refreshAccessToken } from "@/api/AuthAPI/auth-request-api";

interface IwsDone {
  image: string;
  name: string;
}

@Component<SocketIOConnecter>({})
export default class SocketIOConnecter extends Vue {
  isConnected = false;
  socketMessage = "";
  socket: io.Socket | null = null;
  selectedFile: File | null = null;
  fileName = "";
  finelPoster = "";

  progress = {
    value: 0,
    variant: "primary",
  };

  FReader = new FileReader();

  async connect(uri: string, param: string, path: string): Promise<void> {
    console.log(path);

    const auth = {
      token: `Bearer ${this.$store.getters.getAccess}`,
    };
    const base = path
      ? { query: { x: param, path }, auth }
      : { query: { x: param }, auth };
    // dev: uri = http://host:port → прямой коннект (namespace "/", path "/socket.io")
    // prod: uri = /socket/<name> → Engine.IO path через Apache-прокси
    this.socket = /^(https?:)?\/\//i.test(uri)
      ? io.connect(uri, base)
      : io.connect({ ...base, path: uri });
    this.wsMoreData();
    this.wsError(uri, param, path);
    this.wsDone();
  }

  startUpload(size: number): void {
    if (!this.socket) return;
    this.FReader.onload = (evnt) => {
      console.log("onload");
      if (!this.socket) return;
      this.socket.emit("Upload", {
        name: this.fileName,
        data: evnt?.target?.result,
      });
      console.log("Upload");
    };
    this.socket.emit("Start", { name: this.fileName, size });
  }

  wsMoreData(): void {
    if (!this.socket) return;
    this.socket.on("MoreData", (data) => {
      if (!this.selectedFile) return;
      this.progress.value = data["percent"];

      const place = data["place"] * 524288;
      let newFile;
      // eslint-disable-next-line
      // @ts-ignore
      if (this.selectedFile.webkitSlice)
        // eslint-disable-next-line
        // @ts-ignore
        newFile = this.selectedFile.webkitSlice(
          place,
          place + Math.min(524288, this.selectedFile.size - place)
        );
      else
        newFile = this.selectedFile.slice(
          place,
          place + Math.min(524288, this.selectedFile.size - place)
        );
      this.FReader.readAsBinaryString(newFile);
    });
  }

  wsError(uri: string, param: string, path: string): void {
    if (!this.socket) return;
    this.socket.on("401", () => {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
      refreshAccessToken().then(
        (res: { access: string; refreshtoken: string } | undefined) => {
          if (!res) return;
          this.connect(uri, param, path);
        }
      );
    });
    this.socket.on("403", () => {
      alert(this.$i18n.t("error.403"));
    });
    this.socket.on("UploadError", (data: { message: string }) => {
      this.progress.variant = "danger";
      this.progress.value = 0;
      this.socketMessage = data?.message || "Upload error";
      alert(this.socketMessage);
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
    });
  }

  wsDone(): void {
    if (!this.socket) return;
    this.socket.on("Done", (data: IwsDone) => {
      this.progress.value = 100;
      this.finelPoster = data.image;
      this.fileName = data.name;
      console.log("Done");
      this.$emit("done");
    });
  }

  destroyed(): void {
    this.selectedFile = null;
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
